import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';
import {
  Box,
  Button,
  Card,
  CardContent,
	Tab,
	Tabs,
  TextField,
  Typography
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';

import AddCustomerModal from 'components/QuickSale/AddCustomerModal';
import PaymentDisplayTable from 'components/QuickSale/PaymentDisplayTable';

import { setNewSOPaymentInfo, setNewSOCustomerId } from 'redux/actions';
import { VAT_UAE } from 'variables/globalVAT';
import { cash, card, credit } from 'variables/paymentMethods';

const filter = createFilterOptions();

const methods = [cash, card, credit];

const PaymentDisplay = (props) => {

  const [phoneBuffer, setPhoneBuffer] = useState("");
	const [paymentTabValue, setPaymentTabValue] = useState(0);
  const [openCustomerModal, setOpenCustomerModal] = useState(false);

  const subTotal = props.soProducts.reduce((prev, curr) => prev + ( curr.unitPrice * curr.quantity ), 0);
  const totalVat = Math.round( props.currSubTotal * VAT_UAE );
  const grandTotal = props.currSubTotal + totalVat;

  const customersObj = useMemo(() => (
    props.customers
      .map(customer => {
        const firstLetter = customer.name[0].toUpperCase();
        return {firstLetter, id: customer.id, name: customer.name, phone: customer.phone};
      })
      .sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))
    
  ), [props.customers]);

  const customerInput = useMemo(() => {
    if(props.customerId > 0) {
      const customerInfo = props.customers.find(customer => customer.id === props.customerId);
      const firstLetter = customerInfo.name[0].toUpperCase();
      return({firstLetter, id: customerInfo.id, name: customerInfo.name, phone: customerInfo.phone});
    }
    else return null;

  }, [props.customerId, props.customers]);

  const setSalesOrderPayment = () => {
    const paymentInfo = {
      totalVat,
      total: grandTotal,
      paymentMethod: methods[paymentTabValue] || "unknown"
    };
    
    props.setNewSOPaymentInfo(paymentInfo);
    props.saveSalesOrder(paymentInfo);

    setPaymentTabValue(0);
  };

  const handlePaymentTabChange = (event, newValue) => {
		setPaymentTabValue(newValue);
	};

  const handleCustomerModalClose = () => {
    setOpenCustomerModal(false);
    setPhoneBuffer("");
  };

  const handleCancelSO = () => {
    props.salesOrderCleanup();
    setPaymentTabValue(0);
  };

  return (
    <React.Fragment>
    <Card>
      <CardContent>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Autocomplete
            onChange={(event, newValue) => {
              if (newValue && newValue.inputValue) {
                setOpenCustomerModal(true);
                setPhoneBuffer(newValue.inputValue);
              }
              else {
                if(newValue) props.setNewSOCustomerId(newValue.id);
                else props.setNewSOCustomerId(0);
              }
            }}
            filterOptions={(options, params) => {
              const filtered = filter(options, params);
      
              if (params.inputValue !== '') {
                filtered.push({
                  inputValue: params.inputValue,
                  name: "Add customer -",
                  phone: params.inputValue
                });
              }
      
              return filtered;
            }}
            id="free-solo-dialog-demo"
            options={customersObj}
            groupBy={(customer) => customer.firstLetter}
            getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.name} (${option.phone})`}
            style={{ width: 300 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Customer.."
                variant="outlined"
              />
            )}
            value={customerInput}
          />
          <PaymentDisplayTable
            soProducts={props.soProducts}
            currSubTotal={props.currSubTotal}
            setCurrSubTotal={props.setCurrSubTotal}
          />
          <Typography
            color="textPrimary"
            gutterBottom
            variant="h6"
          >
            Sub Total : AED {Number(subTotal).toFixed(2)}
          </Typography>
          <TextField
            helperText="Please Enter the Final Bill Amount"
            label="Total"
            onChange={(event) => props.setCurrSubTotal(parseFloat(event.target.value) || 0)}
            value={props.currSubTotal}
            variant="outlined"
          />
          <Typography
            color="textPrimary"
            gutterBottom
            variant="h6"
          >
            Discount : AED { Number(subTotal - props.currSubTotal < 0 ? 0 : subTotal - props.currSubTotal).toFixed(2)}
          </Typography>
          <Typography
            color="textPrimary"
            gutterBottom
            variant="h6"
          >
            VAT : AED { totalVat }
          </Typography>
          <Typography
            color="textPrimary"
            gutterBottom
            variant="h6"
          >
            Grand Total : AED { grandTotal }
          </Typography>
					<Tabs
						value={paymentTabValue}
						indicatorColor="primary"
						textColor="primary"
						onChange={handlePaymentTabChange}
					>
						<Tab label="Cash"/>
						<Tab label="Card"/>
						<Tab label="Credit"/>
					</Tabs>
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              p: 2
            }}
          >
            <Button
              fullWidth
              disabled={ props.currSubTotal <= 0 || props.customerId === 0 }
              variant="contained"
              color="primary"
              onClick={setSalesOrderPayment}
            >
              Pay Now
            </Button>
            <Button
              fullWidth
              disabled={ props.currSubTotal <= 0 && props.customerId === 0 }
              variant="contained"
              color="secondary"
              onClick={handleCancelSO}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </CardContent>
    </Card>
    { openCustomerModal ?
    <AddCustomerModal
      open={openCustomerModal}
      activeUserId={props.activeUserId}
      activeUserType={props.activeUserType}
      user={props.user}
      closeModal={handleCustomerModalClose}
      customerInfo={{
        displayId: props.createCustomerDisplayId(),
        name: "",
        phone: phoneBuffer,
        addressLine: "Sharjah",
        city: "sharjah",
        country: "UAE",
        trn: ""
      }}
    /> : null }
    </React.Fragment>
  )
};

export default connect (null, {setNewSOPaymentInfo, setNewSOCustomerId}) (PaymentDisplay);